import script from "./ProjectManageSetting.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectManageSetting.vue?vue&type=script&lang=ts&setup=true"

import "./ProjectManageSetting.vue?vue&type=style&index=0&id=6ceb08c0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ceb08c0"]])

export default __exports__